import { environment } from "../../environments/environment";
import { Modules, Userlevel } from "./enums";

// Dev-only simulering av Val21 (se environment.ts). Leses valgfritt slik at
// prod-bygg - der environment.prod.ts erstatter filen - ikke får typefeil.
const SIMULATE_ADMIN_MODULE =
  (environment as { simulateAdminModule?: boolean }).simulateAdminModule ===
  true;

/**
 * ADMIN-modulen krever både rollen Administrator og eksplisitt modultilgang
 * (Modules.AdminSettings, satt via Visma FreeInf3.Val21 og levert i ModuleAccess
 * ved innlogging). Mangler oppføringen, er det ingen tilgang.
 * Serveren håndhever det samme på admin-endepunktene - dette styrer kun UI.
 */
export function hasAdminModuleAccess(
  userLevel: unknown,
  moduleAccess: { Module: number; HideModule: boolean }[] | null | undefined
): boolean {
  if (Number(userLevel) !== Userlevel.Administrator) {
    return false;
  }
  if (SIMULATE_ADMIN_MODULE) {
    return true;
  }
  const entry = (moduleAccess || []).find(
    (m) => Number(m?.Module) === Modules.AdminSettings
  );
  return !!entry && entry.HideModule === false;
}

/** ModuleAccess fra minnet, med fallback til det som ble lagret ved innlogging */
export function readStoredModuleAccess(current: any): any[] | null {
  if (current) {
    return current;
  }
  try {
    const stored = localStorage.getItem("moduleAccess");
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}
